export const COLOR_PALETTE = [
  "#8965E4",
  "#FFA556",
  "#62A0CB",
  "#6BBC6B",
  "#E26868",
  "#AE8981",
  "#EBA0D4",
  "#A5A5A5",
  "#D0D164",
  "#5DD2DD",
];
